import { render, staticRenderFns } from "./NavigateBack.vue?vue&type=template&id=a47b1714&scoped=true"
import script from "./NavigateBack.vue?vue&type=script&lang=ts"
export * from "./NavigateBack.vue?vue&type=script&lang=ts"
import style0 from "./NavigateBack.vue?vue&type=style&index=0&id=a47b1714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47b1714",
  null
  
)

/* custom blocks */
import block0 from "./NavigateBack.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports